import React, { useState } from "react";
import { useForm } from "react-hook-form"
import { auth } from "services/firebase";

export default function Login() {
    const [loading, setLoading] = useState(false);

    const { register, formState: { errors }, handleSubmit } = useForm();

    const onSubmit = async (data) => {
        setLoading(true);

        await auth.signInWithEmailAndPassword(data.email, data.senha)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                // ...
            })
            .catch((error) => {
                console.log(error.code + error.message);
                alert("Houve um erro, tente novamente mais tarde!");
            });

        setLoading(false);
    };

    const renderForm = (
        <>
            <div className="col-12">
                <div className="form-group">
                    <label>Email</label>
                    <input
                        type="email"
                        className="form-control"
                        placeholder="exemplo@email.com"
                        defaultValue={""}
                        {...register("email", {
                            required: true,
                            pattern: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/g,
                        })}
                    />
                    {errors.email?.type === "required" && (
                        <small>Email é obrigatório</small>
                    )}
                    {errors.email?.type === "pattern" && (
                        <small>O email deve estar no formato correto</small>
                    )}
                </div>
            </div>
            <div className="col-12">
                <div className="form-group">
                    <label>Senha</label>
                    <input
                        type="password"
                        className="form-control"
                        placeholder="Senha"
                        defaultValue={""}
                        {...register(`senha`, {
                            required: true,
                        })}
                    />
                    {errors.senha?.type === "required" && (
                        <small>Digite a senha</small>
                    )}
                </div>
            </div>
        </>
    );

    return (
        <section className="py-3">
            <div className="container text-center">
                <h2>Login</h2>
            </div>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-5">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row mb-3">
                                {renderForm}
                            </div>
                            <div className="row justify-content-end align-items-center">
                                <div className="col-12">
                                    {loading ? (
                                        <button className="btn btn-primary btn-block" disabled>
                                            <span className="spinner-border spinner-border-sm" />
                                        </button>
                                    ) : (
                                        <button type="submit" className="btn btn-primary btn-block">
                                            Entrar
                                        </button>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}
